import { __extends } from "tslib";
import { PutBucketAclRequest } from "../models/index";
import { deserializeAws_restXmlPutBucketAclCommand, serializeAws_restXmlPutBucketAclCommand, } from "../protocols/Aws_restXml";
import { getBucketEndpointPlugin } from "@aws-sdk/middleware-bucket-endpoint";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var PutBucketAclCommand = /** @class */ (function (_super) {
    __extends(PutBucketAclCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function PutBucketAclCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    PutBucketAclCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use(getBucketEndpointPlugin(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var handlerExecutionContext = {
            logger: logger,
            inputFilterSensitiveLog: PutBucketAclRequest.filterSensitiveLog,
            outputFilterSensitiveLog: function (output) { return output; },
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    PutBucketAclCommand.prototype.serialize = function (input, context) {
        return serializeAws_restXmlPutBucketAclCommand(input, context);
    };
    PutBucketAclCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restXmlPutBucketAclCommand(output, context);
    };
    return PutBucketAclCommand;
}($Command));
export { PutBucketAclCommand };
//# sourceMappingURL=PutBucketAclCommand.js.map